import { z } from 'zod';

/**
 * Variabile d'ambiente booleana. `z.coerce.boolean()` considera vera qualsiasi stringa
 * non vuota, quindi "false" diventerebbe true: qui si interpretano i valori testuali.
 */
export function daStringaABooleano(v: unknown): unknown {
  if (typeof v !== 'string') return v;
  const s = v.trim().toLowerCase();
  if (['1', 'true', 'yes', 'si', 'sì', 'on'].includes(s)) return true;
  if (['0', 'false', 'no', 'off', ''].includes(s)) return false;
  return v; // lascia che z.boolean() segnali il valore non riconosciuto
}

export const booleanoEnv = z.preprocess(daStringaABooleano, z.boolean());
